import React from 'react';
import { Elements } from '@stripe/react-stripe-js';
import stripePromise from 'consts/stripePromise';
import CheckOutForm from './CheckOutForm';

const Payment = (props) => {
  return (
    <Elements stripe={stripePromise}>
      <CheckOutForm {...props} />
    </Elements>
  );
};

export default Payment;
